define('modules/settings/shop/tabs/JLSettingsTabController',[], function () {
	'use strict';

	return function JLSettingsController($parentScope, $scope, { BASE_TEMPLATES_PATH }) {
		$parentScope.adminFormTabs.push({
			label: 'FIELDS.JL',
			template: BASE_TEMPLATES_PATH + '/settings/shop/form-janoLaw-settings.html',
		});
	};
});

